import { useState } from "react";
import { Grid, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { gradeOptions } from "../../functions/general";
import NunitoText from "../../components/general/NunitoText";
import ReusableAutocompleteWithID from "../../components/general/ReusableAutocompleteWithID";
import ReusableButton from "../../components/general/ReusableButton";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import TitleBar from "../../components/general/TitleBar";
import SectionSubmitRow from "./SectionSubmitRow";
import { TASK_SECTION, isTaskSectionDirty } from "./taskSectionEdit";

const difficultyOptions = ["easy", "intermediate", "hard", "advanced"].map(
  (d) => ({ id: d, name: d })
);
const iconWrapperStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const iconStyle = { fontSize: 36, color: "#000", cursor: "pointer" };
const recommendationContainerStyle = {
  backgroundColor: "#FFF",
  border: "1px solid #707070",
  borderRadius: 16,
  paddingBlock: 20,
};
const gradeOrDifficultyWrapperStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  paddingInline: "30px 60px",
};

export default function RecommendationSection({
  task,
  setTask,
  isReadOnly,
  original,
  isEdit,
  submittingSection,
  onSubmitSection,
}) {
  const [expand, setExpand] = useState(false);
  const { grade_difficulty } = task;

  const updateRecommendation = (index, target, value) => {
    const newTask = structuredClone(task);
    if (target === "add") {
      newTask.grade_difficulty.splice(index + 1, 0, {
        grade: "",
        difficulty: "",
      });
    } else if (target === "remove") {
      newTask.grade_difficulty.splice(index, 1);
    } else {
      newTask.grade_difficulty[index][target] = value;
    }
    setTask(newTask);
  };

  return (
    <>
      <TitleBar title="Recommendations" state={expand} setState={setExpand}>
        {!isReadOnly && (
          <ReusableButton
            text="Add Recommendation"
            fontSize={16}
            bgColor="#5E75C3"
            marginRight={40}
            onClick={() =>
              updateRecommendation(grade_difficulty.length, "add")
            }
            iconType="add"
          />
        )}
      </TitleBar>
      {expand && (
        <AddPageWrapper>
          {grade_difficulty.map(({ grade, difficulty }, index) => (
            <Grid
              key={index}
              container
              alignItems="center"
              style={{ marginTop: index ? 10 : 40, marginBottom: 10 }}
            >
              <Grid item xs={0.5} style={iconWrapperStyle}>
                {!isReadOnly && (
                  <IconButton
                    onClick={() => updateRecommendation(index, "remove")}
                  >
                    <CloseIcon style={iconStyle} />
                  </IconButton>
                )}
              </Grid>
              <Grid item xs={11}>
                <Grid container style={recommendationContainerStyle}>
                  <Grid item xs={6} style={gradeOrDifficultyWrapperStyle}>
                    <NunitoText
                      value="Recommended Grade:"
                      fontSize={20}
                      marginBottom={10}
                      fontWeight={600}
                      italic
                    />
                    <ReusableAutocompleteWithID
                      type="default"
                      placeholder="Grade"
                      width="100%"
                      bgColor="#F2F2F2"
                      disabled={isReadOnly}
                      grayedOut={isReadOnly}
                      state={grade}
                      setState={updateRecommendation}
                      count={index}
                      target={isReadOnly ? "" : "grade"}
                      options={gradeOptions.map((g) => ({
                        id: g.id,
                        option: g.name,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={6} style={gradeOrDifficultyWrapperStyle}>
                    <NunitoText
                      value="Recommended Difficulty:"
                      fontSize={20}
                      marginBottom={10}
                      fontWeight={600}
                      italic
                    />
                    <ReusableAutocompleteWithID
                      type="default"
                      placeholder="Difficulty"
                      width="100%"
                      bgColor="#F2F2F2"
                      disabled={isReadOnly}
                      grayedOut={isReadOnly}
                      state={difficulty}
                      setState={updateRecommendation}
                      count={index}
                      target={isReadOnly ? "" : "difficulty"}
                      options={difficultyOptions.map((d) => ({
                        id: d.id,
                        option: d.name,
                      }))}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {!isReadOnly && (
                <Grid item xs={0.5} style={iconWrapperStyle}>
                  <IconButton
                    onClick={() => updateRecommendation(index, "add")}
                  >
                    <AddIcon style={iconStyle} />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          ))}
          {isEdit && original && !isReadOnly && (
            <SectionSubmitRow
              disabled={
                !isTaskSectionDirty(
                  original,
                  task,
                  TASK_SECTION.RECOMMENDATIONS
                ) || submittingSection !== null
              }
              submitting={submittingSection === TASK_SECTION.RECOMMENDATIONS}
              onSubmit={() => onSubmitSection(TASK_SECTION.RECOMMENDATIONS)}
            />
          )}
        </AddPageWrapper>
      )}
    </>
  );
}
